// Module
var code = "{{#.focused}} focused=\"\" {{/}}\r\n{{^.enabled}} disabled=\"\" {{/}}\r\n{{#.readonly}} readonly=\"\" {{/}}    ";
// Exports
export default code;